// extracted by mini-css-extract-plugin
export default {"customCursor":"CustomCursor_customCursor__mNDv1"};